import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES,
    DOWNLOAD_REPORT,
    HIDDEN_PRICES_VARIANT_B,
    PRICE_HISTORY,
    CONSTRUCTION_PHOTOS
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
}

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>obserwować oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DOWNLOAD_REPORT:
            return {
                title: "Załóż konto, aby pobrać raport",
                description: "Uzyskaj dostęp do widocznych cen oraz wielu innych funkcji na portalu"
            };

        case AuthModalVariant.HIDDEN_PRICES_VARIANT_B:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj ceny</Highlight> wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.PRICE_HISTORY:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj historie cen</Highlight> dla wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };
        case AuthModalVariant.CONSTRUCTION_PHOTOS:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz zdjęcia z budowy</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
import {ReactNode} from "react";

import {Highlight} from "@pg-design/text-module";

export enum AuthModalVariant {
    DEFAULT,
    FAVORITE,
    HIDDEN_PRICES,
    DOWNLOAD_REPORT,
    HIDDEN_PRICES_VARIANT_B,
    PRICE_HISTORY,
    CONSTRUCTION_PHOTOS
}

export interface IAuthModalHeaderContent {
    title: ReactNode;
    description: ReactNode;
}

export const getAuthModalHeaderContent = (variant: AuthModalVariant): IAuthModalHeaderContent => {
    switch (variant) {
        case AuthModalVariant.FAVORITE:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>obserwować oferty</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach."
            };

        case AuthModalVariant.HIDDEN_PRICES:
            return {
                title: (
                    <>
                        Załóż konto, aby <Highlight>odkryć ceny</Highlight>
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.DOWNLOAD_REPORT:
            return {
                title: "Załóż konto, aby pobrać raport",
                description: "Uzyskaj dostęp do widocznych cen oraz wielu innych funkcji na portalu"
            };

        case AuthModalVariant.HIDDEN_PRICES_VARIANT_B:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj ceny</Highlight> wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };

        case AuthModalVariant.PRICE_HISTORY:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>odkryj historie cen</Highlight> dla wszystkich mieszkań na portalu
                    </>
                ),
                description: "Dodaj mieszkania do ulubionych, porównuj oferty i otrzymuj najważniejsze informacje o cenach i promocjach"
            };
        case AuthModalVariant.CONSTRUCTION_PHOTOS:
            return {
                title: (
                    <>
                        Załóż konto i <Highlight>zobacz zdjęcia z budowy</Highlight>
                    </>
                ),
                description: null
            };
        case AuthModalVariant.DEFAULT:
        default:
            return {
                title: null,
                description: null
            };
    }
};
